import React, {useState, useEffect, useMemo, useCallback} from 'react'
import {Draggable} from 'react-beautiful-dnd'
import {connect} from 'react-redux'

import {correctedURL} from '../../../utilities'
import {deletePhoto, setField, setProject} from '../../action_creators'
import {Popover, Button, Modal} from 'antd'

const getItemStyle = (isDragging, draggableStyle) => ({
  userSelect: 'none',
  padding: '0.2rem',
  margin: '0 0 2rem 0',
  ...draggableStyle,
})

const ImageActions = ({ onDelete, onExpand }) => (
  <div className="flex-row padding-1">
    <Button onClick={onDelete}>Delete</Button>
    <Button onClick={onExpand}>Expand</Button>
  </div>
);

const stop = (state, ownProps) => ({
  project: state.project,
  field: state.fields[ownProps.fieldId],
  images: (state.fields[ownProps.fieldId] || {}).images,
  status: state.project.status,
  reviewMode: state.meta.reviewMode
})

const dtop = (dispatch, ownProps) => ({
  deletePhotoOut: ({name, id}) => dispatch(deletePhoto(name, id)),
  setImageURLs: (field) => dispatch(setField(ownProps.fieldId, field)),
  setProject: (project) => dispatch(setProject(project)),
})

export function PhotoContainer({fieldId, provided, ...props}) {
  const {project, field = {}, images, status, reviewMode} = props
  const {deletePhotoOut, setImageURLs, setProject} = props

  const [visible, setVisible] = useState(false)
  const [currentImage, setCurrentImage] = useState({url: null})
  
  const imageList = useMemo(() => Object.values(images || {}), [images]);

  useEffect(() => {
    if (!images) return;
    let hasChanges = false;
    const updatedImages = { ...images };
    const updatedProjectPhotos = project.photos ? { ...project.photos } : {};
    for (let key in updatedImages) {
      if (!updatedImages[key].url) {
        hasChanges = true; // Found a missing URL! We need to work.
        const url = correctedURL(updatedImages[key].fullPath);
        updatedImages[key] = { ...updatedImages[key], url };
        if (updatedProjectPhotos[key]) {
             updatedProjectPhotos[key] = { ...updatedProjectPhotos[key], url };
        }
      }
    }
    if (!hasChanges) return;
    setImageURLs({...field, images: updatedImages});
    setProject({...project, photos: updatedProjectPhotos});
  }, [images, field, project, setImageURLs, setProject]);

  const handleDelete = useCallback((name) => {
    console.log('Deleting photo:', name, fieldId);
    deletePhotoOut({ name, id: fieldId });
  }, [deletePhotoOut, fieldId]);

  const handleExpand = useCallback((image) => {
    setCurrentImage(image);
    setVisible(true);
  }, []);

  const reviewModeActive = status === 'Review' && !reviewMode
  return (
    <div className="flex-column">
      {imageList.length > 0 && <h4 style={{padding: '2.5rem 0 0 0'}}>Attached Photos</h4>}
      <div className="flex-row" ref={provided.innerRef}>
        <div style={{flex: 1}} className={reviewModeActive ? 'flex-column' : 'flex-row'}>
          {imageList.map((image, i) => (
            <Draggable key={image.name} draggableId={`${field.id}prefix${image.name}`} index={i}>
              {(provided, snapshot) => (
                <div style={reviewModeActive ? {flex: 1} : {width: '12.5%'}}>
                  <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                  >
                    <Popover 
                    content={
                        <ImageActions 
                          onDelete={() => handleDelete(image.name)} 
                          onExpand={() => handleExpand(image)} 
                        />
                    } 
                    title="Action">
                      <img
                        className="full-width"
                        style={{border: '1px solid lightgrey'}}
                        src={image.url}
                        alt="intake question"
                      />
                    </Popover>
                  </div>
                </div>
              )}
            </Draggable>
          ))}
        </div>
      </div>
      <Modal title="Expanded Image" visible={visible} onCancel={() => setVisible(false)} footer={null}>
        <img alt="user uploaded" style={{width: '100%', height: '100%'}} src={currentImage.url} />
      </Modal>
    </div>
  )
}

const WrappedPhotoContainer = connect(stop, dtop)(PhotoContainer)
export default WrappedPhotoContainer
